import { inject, Injectable } from '@angular/core';
import { Color } from '@swimlane/ngx-charts';
import { TranslateService } from '@ngx-translate/core';
import { BreadcrumbsService } from '../../shared/breadcrumbs/breadcrumbs.service';
import { BottomNavService, BottomNavUpdateButtonState } from '../../shared/bottom-nav/bottom-nav.service';
import { COLOR_PALETTE, MigrationsService } from './migrations.service';

export type ColorPalette = keyof typeof COLOR_PALETTE;

export interface CustomColor {
  name: string;
  value: (typeof COLOR_PALETTE)[ColorPalette] | `url(#${string})`;
}

@Injectable()
export class MigrationsDashboardService {
  private _translateService = inject(TranslateService);
  private _breadcrumbsService = inject(BreadcrumbsService);
  private _bottomNavService = inject(BottomNavService);

  readonly usageTypeCustomColors: CustomColor[] = [{ name: 'unclassified', value: COLOR_PALETTE.danger }];
  readonly deviceTypeCustomColors: CustomColor[] = [{ name: 'unclassified', value: COLOR_PALETTE.danger }];
  readonly migrationStatusCustomColors: CustomColor[] = Array.from(
    MigrationsService.MIGRATION_STATUS_ROW_MAP.values(),
  ).map((val) => ({ name: val.label, value: val.iconColor as (typeof COLOR_PALETTE)[ColorPalette] }));

  createColorScheme(colors: (keyof typeof COLOR_PALETTE)[]): Color {
    return { domain: colors.map((color) => COLOR_PALETTE[color]) } as Color;
  }

  createDefaultColorScheme(): Color {
    return this.createColorScheme(Object.keys(COLOR_PALETTE) as (keyof typeof COLOR_PALETTE)[]);
  }

  setRefreshButtonPendingState(refreshButtonId: string, state: boolean): void {
    this._bottomNavService.dispatch(
      new BottomNavUpdateButtonState({
        id: refreshButtonId,
        state: {
          pending: state,
          buttonDisableState: { disabled: state, tooltipKey: '' },
        },
      }),
    );
  }

  updateDashboardBreadcrumbs(tenantId: string, assessmentName: string): void {
    this._breadcrumbsService.updateBreadcrumbs([
      { label: 'tkey;migrations.title', routerLink: true, url: `/migrations/tenants/${tenantId}` },
      {
        label: this._translateService.instant('tkey;migrations.number_report.dashboard.breadcrumb', {
          name: assessmentName,
        }),
      },
    ]);
  }
}
